import wallet from 'store/wallet/reducer';

export default {
  wallet,
};
